import { useEffect, useState } from 'react';
import { PublishedFamilyTreeRecord } from '../types/familyTree';
import { SurveillancePlanRecord, SurveillanceReviewPrompt } from '../types/surveillance';
import { getMemberSurveillanceOverview } from '../services/memberSurveillanceService';

interface UseMemberSurveillanceOverviewResult {
  loading: boolean;
  latestPlan: SurveillancePlanRecord | null;
  openPrompts: SurveillanceReviewPrompt[];
  familyTree: PublishedFamilyTreeRecord | null;
}

export default function useMemberSurveillanceOverview(userId?: string | null): UseMemberSurveillanceOverviewResult {
  const [loading, setLoading] = useState(true);
  const [latestPlan, setLatestPlan] = useState<SurveillancePlanRecord | null>(null);
  const [openPrompts, setOpenPrompts] = useState<SurveillanceReviewPrompt[]>([]);
  const [familyTree, setFamilyTree] = useState<PublishedFamilyTreeRecord | null>(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      if (!userId) {
        if (!active) return;
        setLatestPlan(null);
        setOpenPrompts([]);
        setFamilyTree(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const overview = await getMemberSurveillanceOverview(userId);
        if (!active) return;
        setLatestPlan(overview.latestPlan);
        setOpenPrompts(overview.openPrompts);
        setFamilyTree(overview.familyTree);
      } catch (error) {
        console.error('Error loading member surveillance overview:', error);
        if (!active) return;
        setLatestPlan(null);
        setOpenPrompts([]);
        setFamilyTree(null);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [userId]);

  return { loading, latestPlan, openPrompts, familyTree };
}
